import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions, ResponseOptions, ResponseOptionsArgs } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Observer } from 'rxjs';
import 'rxjs/add/operator/map';
import { StorageService } from './StorageService';


import { environment } from '../../../environments/environment';
import { MessageCenter } from '../utils/MessagesCenter';
import { ErrorObservable } from "rxjs/observable/ErrorObservable";
import { Router, ActivatedRoute } from '@angular/router';
import { UserInfo } from '../../model/user';
import { ValidateUserWithPasswordRequestModel, LogoutUserRequestModel } from '../../model/models';


@Injectable()
export class AuthenticationService {

    public token: string;

    constructor(private http: Http,
         private httpClient : HttpClient, 
         private storage: StorageService, 
         private messageCenter: MessageCenter,  
         private router: Router) {
       
    };

    login(loginRequestModel: ValidateUserWithPasswordRequestModel) :Observable<Response>{
        
    
        return this.http.post(environment.server_url+"/api/ValidateUserWithPassword", loginRequestModel)
        .map((response: Response) => {

                // login successful if there's a jwt token in the response

                  let token = (response.json() && response.json().SecurityToken);
                if (token) {
                     let userSessionId: number = response.json().SessionID;

                     console.log("user==>",userSessionId);

                    // set token property
                    this.token = token;
                    // store userSessionId and jwt token in local storage to keep user logged in between page refreshes
                    this.storage.setSessionData({ "userSessionId" : userSessionId,  "token": token });

                } 
                return response;
                

        });


    }

    logout(): void {
        // clear token remove user from local storage to log user out
       
        this.token = null;
        this.storage.clear();
        this.router.navigate(['/login']); 
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/security/AuthenticationService.ts